import { getTokenFromCookie } from '~/utils/getTokenFromCookie'
import gql from 'graphql-tag'

export const GET_VIEWER = gql`
  query getViewerInfo {
    viewer {
      id
      chatVerificationId
      city
      locationCountryCode
      avatar
      firstname
      lastname
      successfullySoldCount
      isEmployee
      hasAgreedToLatestTermsAndPrivacyPolicy
      createdAt
      email
      isPhoneVerified
      isEmailVerified
      facebookUserPermissions {
        handle
        granted
      }
      facebookAccount {
        friendsCount
      }
      twitterAccount {
        id
      }
      cart {
        id
      }
      isReceivingEmailNotifications
      locale
      accountAlerts {
        title
        url {
          url
          trackingUrl
          path
        }
        description
      }
      userDevices {
        name
      }
    }
  }
`

export default async (apolloClient, req) => {
  const token = getTokenFromCookie(req)

  try {
    const { data } = await apolloClient.query({
      query: GET_VIEWER,
      skip: !token,
    })

    if (data.viewer !== null) {
      return data.viewer
    }
  } catch {}

  return null
}
